export const jobsApiErrors: Record<string, string> = {
  FLEET_JOB_UID_NOT_FOUND: 'fleetJobUidNotFound',
};
